import { render, staticRenderFns } from "./textAreaField.vue?vue&type=template&id=1765c94a&"
import script from "./textAreaField.vue?vue&type=script&lang=ts&"
export * from "./textAreaField.vue?vue&type=script&lang=ts&"
import style0 from "./textAreaField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports